import React, { useState } from "react";
import GreenDotIcon from "../../assets/img/GreenDotIcon.svg";
import DownloadIcon from "../../assets/icons/downloadIcon.svg";
import BaseButton from "../base/BaseButton";
import moment from "moment";
import { ViewResultModal } from "../organisation";
import { UploadedResultPdf } from "../../store/slices/order/types";

const OldResultItem = ({
  oldResultItem,
}: {
  oldResultItem: UploadedResultPdf;
}) => {
  const [isResultModalOpen, setIsResultModalOpen] = useState(false);

  const viewResultModal = () => {
    // if (!customerDashboardInfo?.mobile) {
    //     setShowMobileModal(true);
    //     return;
    // }
    // if (!customerDashboardInfo?.isMobileVerified) {
    //     setOpenVerificationModal(true);
    //     return;
    // }
    setIsResultModalOpen(true);
  };
  const closeResultModal = () => {
    setIsResultModalOpen(false);
  };

  // const viewResult = () => {
  //     setShow(true);
  // };

  const handleDownload = () => {
    // if (!customerDashboardInfo?.mobile) {
    //     setShowMobileModal(true);
    //     return;
    // }

    // if (!customerDashboardInfo?.isMobileVerified) {
    //     setOpenVerificationModal(true);
    //     return;
    // }

    fetch(
      `https://healthtracka-s3-bucket.s3.eu-west-2.amazonaws.com/${oldResultItem?.url}`
    )
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "result";
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch(() => {
        console.error("Error downloading file.");
      });
  };
  const url = oldResultItem?.url.split("/");
  const urlName = url[5];

  return (
    <>
      <div className="hidden lg:flex justify-between items-center bg-white lg:px-4 xl:px-8 py-6 rounded-[0.5rem] mb-4">
        <div className="flex items-center">
          <div className="">
            <img
              src={GreenDotIcon}
              alt="green dot icon"
              className="w-full h-full"
            />
          </div>
          <div className="mx-2 xl:mx-4 flex">
            <h3 className="text-[0.875rem] text-[#0C4654] font-[500]">{`Result ${urlName}`}</h3>

            <h3 className="text-[0.875rem] text-[#0C4654] px-1 font-[500]">{`(${moment(
              oldResultItem?.createdAt
            ).format("Do MMMM, YYYY")})`}</h3>
          </div>
          <div className="mx-2 xl:mx-4">
            {/* <p className="rounded-[0.25rem] lg:text-[0.625rem] xl:text-[0.75rem] bg-[#A2E0A2] bg-opacity-50 text-[#2F5B3E] font-[700] px-2 py-1">
                            RESULT RECEIVED
                        </p> */}

            {/* {results.isResultComplete ? (
                            <BaseStatusLabel status={'ResultSentComplete'} />
                        ) : (
                            <BaseStatusLabel status={'ResultSentIncomplete'} />
                        )} */}
          </div>
        </div>
        <div className="flex items-center justify-center mx-4">
          <BaseButton
            text="View Result"
            variant="primary"
            styles="!bg-[#3A966C] !text-[0.875rem] px-4 !h-10 font-[500] xl:w-full xl:!px-8"
            click={viewResultModal}
          ></BaseButton>

          <BaseButton
            text="Download"
            variant="primary"
            hasRightIcon={true}
            styles="!bg-[#F2F6FA] !text-[#525256] px-4 mx-4 !h-10 font-[500] xl:w-full xl:!px-8"
            click={handleDownload}
          >
            <img
              src={DownloadIcon}
              alt="download"
              className="w-[25px] xl:w-[20px] ml-2"
            />
          </BaseButton>
        </div>
        {/* {(order?.status === 'ResultSentComplete' || order?.status === 'ResultSentIncomplete') && (
                    <div className="flex items-center justify-center">
                    <div>
                    <BaseButton
                                text="View Result"
                                variant="primary"
                                styles="!bg-[#3A966C] !text-[0.875rem] px-4 !h-10 font-[500] xl:w-full xl:!px-8"
                                click={viewResultModal}
                                />
                                </div>
                                <div className="mx-5">
                                    <BaseButton
                                        click={handleDownload}
                                        text="Download"
                                        hasRightIcon={true}
                                        variant="neutral"
                                        styles="!bg-[#F2F6FA] text-[#525256] !text-[0.875rem]  border-0 !h-10  font-[500] px-4 xl:!px-8 xl:w-full">
                                        <Image src={ArrowUp} alt="green dot icon" className="w-[15px] xl:w-[20px] ml-2" />
                                    </BaseButton>
                                </div>
                                </div>
                )} */}
      </div>
      <div className="flex flex-col bg-[#F2F6FA] rounded-[1rem] pb-10 lg:hidden">
        <div className="bg-white w-full px-5 py-6 rounded-[1.5rem]">
          <div className=" w-fit">
            {/* <p className="rounded-[0.25rem] lg:text-[0.625rem] xl:text-[0.75rem] bg-[#A2E0A2] bg-opacity-50 text-[#2F5B3E] font-[700] px-2 py-1">
                            RESULT RECEIVED
                        </p> */}

            {/* {results.isResultComplete ? (
                            <BaseStatusLabel status={'ResultSentComplete'} />
                        ) : (
                            <BaseStatusLabel status={'ResultSentIncomplete'} />
                        )} */}
          </div>
          <div className="my-4">
            <h3 className="text-[0.875rem] text-[#0C4654] font-[400]">{`Result ${urlName}`}</h3>

            <h3 className="text-[0.875rem] text-[#0C4654] font-[500]">{`(${moment(
              oldResultItem?.createdAt
            ).format("Do MMM, YYYY")})`}</h3>
          </div>
          <div className=" items-center justify-center ">
            <BaseButton
              text="View PDF"
              variant="primary"
              styles="!bg-[#3A966C] !text-[0.875rem] px-4 mb-4 !h-10 font-[500] w-full xl:!px-8"
              click={viewResultModal}
            ></BaseButton>

            <BaseButton
              text="Download"
              variant="primary"
              hasRightIcon={true}
              styles="!bg-[#F2F6FA] !text-[#525256] px-4 !h-10 font-[500] w-full xl:!px-8"
              click={handleDownload}
            >
              <img
                src={DownloadIcon}
                alt="download"
                className="w-[25px] xl:w-[20px] ml-2"
              />
            </BaseButton>
          </div>
        </div>
      </div>
      <ViewResultModal
        isResultOpen={isResultModalOpen}
        record={oldResultItem}
        closeModal={closeResultModal}
      />
    </>
  );
};

export default OldResultItem;
